import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    menuBar: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
      padding: 15,
      cursor: 'pointer',
      marginBottom: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& > p': {
        color: `${theme.palette.primary.main}`,
      },
    },
    content: {
      padding: 15,
      paddingBottom: 0,
      '& div':{
        marginBottom: 15,
      },
      '& div:last-child':{
        marginBottom: 5,
      }
    },
    emptySpace: {
      textAlign: 'center',
      marginBottom: 20,
    },
    arrowContent: {
      display: 'flex',
      alignItems: 'center',
  
      '& *': {
        marginLeft: 10,
        color: theme.palette.primary.main,
      },
    },
    transferredItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      padding: '20px 30px 10px 30px',
      '& div':{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        marginLeft: 5,
        '& p:first-child': {
            color:
              theme.palette.type === 'dark'
                ? theme.palette.hover4
                : theme.palette.text.primary,
        },
        '& p':{
          width: '50%',
        }
      }
    },
    divider:{
      marginTop: 5,
      marginBottom: 10,
    },
    transferIcon: {
      fontSize: 16,
      marginRight: 5,
    }
  }))

export default useStyles
